<ea-alert
  [alertId]="field.id"
  [attr.data-automation-id]="field.automationId"
  [alertStatus]="'' + alertType"
  [showAlert]="field.visible"
  class="fs-unmask bl-display--block bl-margin-bottom--24 bl-margin-top-0"
  [heading]="field.label"
  [message]="message"
  [ngClass]="formatter"
>
</ea-alert>
